module.exports = "/_next/static/images/mobile-application-banner-icon-4c0e06c4c06a663e5b0436287c65fad0.webp";